<template>
    <div class="interMain" :class="[{ 'show': show }, { 'active': active }]">
        <div class="top"></div>
        <div class="bom"></div>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue'

const show = ref(false)
const active = ref(false)

const setInterFun = (v) => {
    if (v) {
        show.value = true
        active.value = true
    } else {
        active.value = false
        setTimeout(() => {
            show.value = false
        }, 1500);
    }
}




defineExpose({ setInterFun })



</script>
<style scoped lang="scss">
.interMain {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: -11;
    opacity: 0;

    .top {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: -100%;
        background: url('../../assets/img/base/top.png') no-repeat center;
        background-size: 100% 100%;
        transition: 1s;
    }

    .bom {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        bottom: -100%;
        background: url('../../assets/img/base/bom.png') no-repeat center;
        background-size: 100% 100%;
        transition: 1s;
    }

    &.active {
        .top {
            top: 0;
        }

        .bom {
            bottom: 0;
        }
    }

    &.show {
        z-index: 9999;
        opacity: 1;
    }
}
</style>